<template>
  <div class="error-page">
    <div class="error-page__image-wrap">
      <div class="error-page__image-el">
        <img src="/img/404/number.jpg" alt="number img" />
      </div>
      <div class="error-page__image-el error-page__image-el--spin">
        <img src="/img/404/disc.jpg" alt="disc img" />
      </div>
      <div class="error-page__image-el">
        <img src="/img/404/number.jpg" alt="number img" />
      </div>
    </div>

    <div class="error-page__title-wrap">
      <h1 class="error-page__title">{{ $t('error.page.title') }}</h1>
    </div>

    <div class="error-page__subtitle-wrap">
      <span class="error-page__subtitle" v-html="$t('error.page.subtitle')"></span>
    </div>

    <div class="error-page__links-wrap">
      <Button
        :href="urlLanguagePrefix + '/sale/'"
        class="arrows-btn"
      >
        <svg class="arrows-btn__decor arrows-btn__decor-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.19141 4.02832L9.19141 4.02734L15.8457 10.6836L15.8467 10.6826L17.1768 12.0137L15.8467 13.3457L15.8457 13.3457L9.19238 20L7.85938 18.6689L14.5146 12.0146L7.85938 5.35645L9.19141 4.02832Z" fill="white"/>
        </svg>
        <svg class="arrows-btn__decor arrows-btn__decor-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.19141 4.02832L9.19141 4.02734L15.8457 10.6836L15.8467 10.6826L17.1768 12.0137L15.8467 13.3457L15.8457 13.3457L9.19238 20L7.85938 18.6689L14.5146 12.0146L7.85938 5.35645L9.19141 4.02832Z" fill="white"/>
        </svg>
        <svg class="arrows-btn__decor arrows-btn__decor-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.19141 4.02832L9.19141 4.02734L15.8457 10.6836L15.8467 10.6826L17.1768 12.0137L15.8467 13.3457L15.8457 13.3457L9.19238 20L7.85938 18.6689L14.5146 12.0146L7.85938 5.35645L9.19141 4.02832Z" fill="white"/>
        </svg>
        <span>{{ $t('error.page.link.sale') }}</span>
        <svg class="arrows-btn__decor arrows-btn__decor-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.8086 19.9717L14.8086 19.9727L8.1543 13.3164L8.15332 13.3174L6.82324 11.9863L8.15332 10.6543L8.1543 10.6543L14.8076 4L16.1406 5.33106L9.48535 11.9854L16.1406 18.6436L14.8086 19.9717Z" fill="white"/>
        </svg>
        <svg class="arrows-btn__decor arrows-btn__decor-5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.8086 19.9717L14.8086 19.9727L8.1543 13.3164L8.15332 13.3174L6.82324 11.9863L8.15332 10.6543L8.1543 10.6543L14.8076 4L16.1406 5.33106L9.48535 11.9854L16.1406 18.6436L14.8086 19.9717Z" fill="white"/>
        </svg>
        <svg class="arrows-btn__decor arrows-btn__decor-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.8086 19.9717L14.8086 19.9727L8.1543 13.3164L8.15332 13.3174L6.82324 11.9863L8.15332 10.6543L8.1543 10.6543L14.8076 4L16.1406 5.33106L9.48535 11.9854L16.1406 18.6436L14.8086 19.9717Z" fill="white"/>
        </svg>
      </Button>
      <Button
        :href="urlLanguagePrefix + '/'"
        class="to-main-btn"
        type="plain"
      >
        {{ $t('error.page.link.main') }}
      </Button>
    </div>

    <rendered-blocks uid="not-found" without-container></rendered-blocks>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { EsputnikService } from '@/services/AnalyticService'
import Button from '@/components/inputs/Button.vue'
import RenderedBlocks from '@/components/rendered-blocks/RenderedBlocks'

export default {
  name: 'ErrorPage',
  components: {
    RenderedBlocks,
    Button
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      userDataFromServer: state => state.user.user_data,
      config: state => state.init.config,
      isBonusServiceActive () {
        return this.config.service?.is_bonus_service_active
      }
    }),
    links () {
      const result = [
        {
          title: this.$t('error.page.link.main'),
          url: `${this.urlLanguagePrefix}/`
        },
        {
          title: this.$t('error.page.link.sale'),
          url: `${this.urlLanguagePrefix}/sale/`
        }
      ]
      if (this.isBonusServiceActive) {
        result.push({
          title: this.$t('error.page.link.bonuses'),
          url: `${this.urlLanguagePrefix}/loyalty-program/`
        })
      }
      return result
    }
  },
  created () {
    EsputnikService.sendErrorPageInfo()
  }
}
</script>

<style scoped lang="sass">
@-webkit-keyframes flash
  0%, 50%, 100%
    opacity: 1

  25%, 75%
    opacity: 0
.to-main-btn
  font-size: 14px
  font-weight: 500
  padding: 11.5px 42px
.arrows-btn
  margin-bottom: 16px
  padding: 9px 27px
  font-size: 14px
  line-height: 500
  display: flex
  align-content: center
  span
    padding: 0 10px
    line-height: 24px
  &__decor
    animation: flash 3s infinite
    &-1, &-6
      animation-delay: 0s
    &-2, &-5
      animation-delay: 0.33s
    &-3, &-4
      animation-delay: 0.66s
    &-2, &-3
      margin-left: -8px
    &-4, &-5
      margin-right: -8px
.error-page
  width: 100%

.error-page__image-wrap
  width: 100%
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center
  padding: 0 15px
  pointer-events: none
  touch-action: none
  user-select: none

.error-page__image-el

  &--spin
    z-index: -1
    animation-name: spin
    animation-direction: reverse
    animation-duration: 4000ms
    animation-iteration-count: infinite
    animation-timing-function: linear

.error-page__title-wrap
  margin: 40px 0 0
  padding: 0 40px

.error-page__title
  font-size: 20px
  font-weight: 500
  letter-spacing: 0.02em
  text-transform: uppercase
  text-align: center

  +mmin($tablet--hor)
    font-size: 28px

.error-page__subtitle-wrap
  margin: 20px 0 0
  padding: 0 30px

.error-page__subtitle
  display: block
  font-size: 16px
  line-height: 150%
  text-align: center

.error-page__links-wrap
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  margin: 30px 0 0

  +mmin($tablet--hor)
    margin: 20px 0 0

.error-page__link
  font-size: 16px
  -webkit-appearance: none

  &:not(:last-child)
    margin-right: 40px

@keyframes spin
  from
    transform: rotate(0deg)

  to
    transform: rotate(360deg)

</style>
